import React, { useEffect, useRef } from 'react'
import propTypes from 'prop-types'
import ServiceTimeLine from '../../spareParts/components/ServiceTimeLine'
import { Typography, LinearProgress } from '@material-ui/core'

const SeriesHistoryTabPanel = ({
    service,
    serialHistory,
    onSearchHistoryBySerie,
    isLoading
}) => {
    // Track last fetched serie to avoid refetching for the same value
    const lastFetchedSerie = useRef(null)
    useEffect(() => {
        if (
            service &&
            service.Equipments &&
            service.Equipments.length > 0 &&
            onSearchHistoryBySerie
        ) {
            const serie = service.Equipments[0].Serie
            if (
                serie &&
                serie.length === 12 &&
                lastFetchedSerie.current !== serie
            ) {
                lastFetchedSerie.current = serie
                onSearchHistoryBySerie(serie)
            }
        }
    }, [service, onSearchHistoryBySerie])

    if (isLoading) {
        return <LinearProgress />
    }

    if (!serialHistory || !serialHistory.Services || serialHistory.Services.length === 0) {
        return (
            <Typography variant="body2" color="textSecondary">
                No service history found for this equipment.
            </Typography>
        )
    }

    return <ServiceTimeLine serviceHistory={serialHistory.Services} />
}

SeriesHistoryTabPanel.propTypes = {
    service: propTypes.object.isRequired,
    serialHistory: propTypes.object,
    onSearchHistoryBySerie: propTypes.func.isRequired,
    isLoading: propTypes.bool
}

SeriesHistoryTabPanel.defaultProps = {
    serialHistory: null,
    isLoading: false
}

export default SeriesHistoryTabPanel